import React, { Component, Fragment } from 'react';
import { ModalBody, ModalFooter, Table } from 'reactstrap';
import { connect } from 'react-redux';
import ListActionSubheader from '../../common/ListActionSubheader';
import AttachmentListItem from './AttachmentListItem';
import AddActionButton from '../../common/AddActionButton';
import Modal from '../../../../shared/ui/Modal';
import attachmentsActionCreators from '../../../store/attachments/action-creators';

class AttachmentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attachmentGuid: '',
      confirmDeleteMessage: '',
      isModalOpen: false,
    };
  }

  // ----------------------
  // Methods
  // ----------------------

  deleteAttachment() {
    this.props.deleteAttachment(this.state.attachmentGuid);
    this.setState({
      attachmentGuid: '',
      confirmDeleteMessage: '',
      isModalOpen: false,
    });
  }

  confirmDeleteAttachment(attachmentFilename, attachmentGuid) {
    this.setState({
      attachmentGuid,
      confirmDeleteMessage: `Delete attachment labelled "${attachmentFilename}"?`,
      isModalOpen: true,
    });
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>


        <ListActionSubheader title="Attachments">
          { !this.props.disableEdit && (
            <AddActionButton
              label="Attachment"
              onAdd={() => this.props.onAdd()}
            />
          )}
        </ListActionSubheader>

        <Table className="layout-auto">
          <thead>
            <tr>
              <th>File Name</th>
              <th>Uploaded By</th>
              <th>Uploaded At</th>
              {!this.props.disableEdit && (
                <th>Actions</th>
              )}
            </tr>
          </thead>
          <tbody>
            {this.props.attachments && this.props.attachments.length > 0 ? (
              this.props.attachments.map((attachment, index) => (
                <AttachmentListItem
                  attachment={attachment}
                  key={index.toString()}
                  disableEdit={this.props.disableEdit}
                  onDelete={(attachmentToDelete) => {
                    return this.confirmDeleteAttachment(
                      attachmentToDelete.filename,
                      attachmentToDelete.guid,
                    );
                  }}
                />
              ))
            ) : (
              <tr>
                <td colSpan="4">
                  <div className="alert alert-primary">No attachments found</div>
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        <Modal
          isOpen={this.state.isModalOpen}
          onClose={() => this.setState({ isModalOpen: false })}
          title="Confirm Delete Attachment"
        >
          <ModalBody>{this.state.confirmDeleteMessage}</ModalBody>
          <ModalFooter>
            <button
              className="button primary"
              onClick={() => this.deleteAttachment(this.state.attachmentGuid)}
            >
              Delete
            </button>
            <button
              className="button"
              onClick={() => this.setState({ isModalOpen: false })}
            >
              Cancel
            </button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapDispatchToProps = (dispatch) => {
  return {
    deleteAttachment: (attachmentGuid) => {
      return dispatch(attachmentsActionCreators.deleteAttachment(attachmentGuid));
    },
  };
};

export default connect(null, mapDispatchToProps)(AttachmentList);
